<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    @click="$emit('click')"
  >
    <path d="M0 0h24v24H0z" />
    <path
      width="100%"
      height="100%"
      d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "NotificationIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
